import { FC, useEffect, useState } from 'react'
import { CSSTransition } from 'react-transition-group'

import { IAnimationWrap, ANIMATION_POPUP_TIME, AnimationTypeVoc } from './data'

const AnimationWrap: FC<IAnimationWrap> = ({ children, animationType, opened }) => {
  const [animationIn, setAnimationIn] = useState(opened)

  useEffect(() => {
    setAnimationIn(opened)
  }, [opened])

  return (
    <CSSTransition
      in={animationIn}
      timeout={ANIMATION_POPUP_TIME}
      mountOnEnter
      unmountOnExit
      classNames={AnimationTypeVoc[animationType]}
    >
      {children}
    </CSSTransition>
  )
}

export default AnimationWrap
